import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './costo_utils';

export const useCostoStore = defineStore('costoStore', {
  state: () => ({
    entity: 'costo',
    costos: [],
    costo: {},
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllCostosHTTP(params) {
      console.log(params);
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.costos = [...result.data];
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstCosto() {
      this.setPage(1);
      this.emptyList();
      await this.findAllCostosHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.costos = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
